import { Component } from "@angular/core";
import { GlobalUtilsService } from "../global-utils.service";

@Component({
  selector: "app-falar-vendedor-button",
  template: `
    <a href="https://wa.me/5584986845330?text=%C2%A9%20Sonora%20Musical%0A%3E%3E%0AOl%C3%A1!%20Obrigado%20pelo%20contato!%20Como%20posso%20ajudar%20voc%C3%AA%3F" class="whatsapp-button {{activeClass}}" target="_blank">
      <span class="whats-content">
        <svg
          class="whats-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            id="Caminho_127"
            data-name="Caminho 127"
            d="M131.453,115.753a9.782,9.782,0,0,0-9.818,9.743,9.637,9.637,0,0,0,1.41,5.03l-1.774,5.227,5.436-1.727a9.766,9.766,0,1,0,4.745-18.273Zm4.882,13.442a2.53,2.53,0,0,1-1.737,1.119c-.46.026-.473.357-2.982-.734a10.243,10.243,0,0,1-4.14-3.913,4.816,4.816,0,0,1-.926-2.61,2.786,2.786,0,0,1,.956-2.041.969.969,0,0,1,.68-.287c.2,0,.325,0,.471,0s.366-.03.556.475.644,1.748.7,1.874a.456.456,0,0,1,0,.436,1.734,1.734,0,0,1-.267.406c-.131.139-.274.315-.392.421s-.267.248-.13.5a7.493,7.493,0,0,0,1.331,1.774,6.8,6.8,0,0,0,1.968,1.309c.246.135.394.12.546-.041s.653-.7.83-.946.342-.195.569-.1,1.436.74,1.682.873.411.2.469.308a2.047,2.047,0,0,1-.19,1.177Z"
            transform="translate(-121.271 -115.753)"
            fill="#f8f8f8"
          />
        </svg>
        FALAR COM VENDEDOR
      </span>
    </a>
  `,
  styles: [
    `
      .whatsapp-button {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f27c00;
        color: white;
        text-transform: uppercase;
        padding: 0.35rem 0;
        padding-top: 0.4rem;
        border-radius: 3.5rem;
        font-size: 0.37rem;
        width: 100%;
        text-decoration: none;
      }

      .whats-content {
        display: flex;
        align-items: center;
        transition: transform 0.2s;
      }

      .whats-icon {
        width: 0.5rem;
        height: 0.5rem;
        margin-top: -0.1rem;
        margin-right: 0.25rem;
        transition: transform 0.2s;
      }

      .whatsapp-button:hover .whats-content,
      .whatsapp-button:hover .whats-icon {
        transform: scale(1.04);
      }

      .whatsapp-button:hover {
        background-color: #ff9800;
      }

      .whatsapp-button.tablet {
        font-size: 0.7rem;
        padding: 0.6rem 1.85rem;
      }

      .whatsapp-button.tablet .whats-icon {
        width: 0.9rem;
        height: 0.9rem;
      }

      .whatsapp-button.mobile {
        font-size: 0.55rem;
        padding: 0.45rem 1.85rem;
      }

    `,
  ],
})
export class FalarVendedorButtonComponent {
  public activeClass = this.globalUtilsService.activeScreen;
  constructor(public globalUtilsService: GlobalUtilsService) {}
}
